module.exports = __webpack_public_path__ + "static/media/2040315000.5a560cf9.jpg";